/* XENITH CORE — interactions (no dependencies, ~3KB) */
(function () {
  'use strict';
  if (window.__xcInit) return;
  window.__xcInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('xc-js');

  /* ---------- hero boot sequence (adds .xc-booted once, CSS drives timing) ----------
     モバイル回線ではヒーロー画像のロード前にシーケンスが終わり「動いていない」ように
     見えるため、可視ヒーロー画像のロードを最大1200msだけ待ってから起動する */
  var xcBootDone = false;
  function xcBoot() {
    if (xcBootDone) return;
    xcBootDone = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.add('xc-booted');
      });
    });
  }
  (function () {
    if (reduced) { xcBoot(); return; }
    var heroImg = null;
    document.querySelectorAll('.xc-tmhero-visual img, .xc-hero__bgart img, .xc-hero__media img').forEach(function (img) {
      if (!heroImg && img.offsetParent !== null) heroImg = img;
    });
    if (heroImg && !heroImg.complete) {
      heroImg.addEventListener('load', xcBoot, { once: true });
      heroImg.addEventListener('error', xcBoot, { once: true });
      setTimeout(xcBoot, 1200);
    } else {
      xcBoot();
    }
  })();

  /* ---------- scroll reveal ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    document.querySelectorAll('[data-xc-reveal], .xc-sechead').forEach(function (el, i) {
      el.style.setProperty('--xc-i', el.dataset.xcI || 0);
      io.observe(el);
    });
  } else {
    document.querySelectorAll('[data-xc-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- count-up ---------- */
  function countUp(el) {
    var target = parseFloat(el.dataset.xcCount), dec = (el.dataset.xcCount.split('.')[1] || '').length;
    var t0 = null, dur = 900;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (!reduced && 'IntersectionObserver' in window) {
    var ioCount = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); ioCount.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-xc-count]').forEach(function (el) { ioCount.observe(el); });
  }

  /* ---------- hero parallax (desktop only, transform-only) ---------- */
  var heroImg = document.querySelector('.xc-hero__media img');
  if (heroImg && !reduced && window.matchMedia('(min-width: 990px)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900);
        heroImg.style.transform = 'translateY(' + y * 0.04 + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- gallery progress ---------- */
  document.querySelectorAll('[data-xc-gallery]').forEach(function (g) {
    var track = g.querySelector('.xc-gallery__track');
    var bar = g.querySelector('.xc-gallery__bar i');
    var count = g.querySelector('.xc-gallery__count');
    var items = track ? track.children.length : 0;
    if (!track || !bar) return;
    bar.style.width = (100 / items) + '%';
    track.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + p * (items - 1) * 100 + '%)';
        if (count) count.textContent =
          String(Math.round(p * (items - 1)) + 1).padStart(2, '0') + ' / ' + String(items).padStart(2, '0');
      });
    }, { passive: true });
  });

  /* ---------- color unit selection (radio + variant sync) ---------- */
  document.querySelectorAll('[data-xc-colors]').forEach(function (c) {
    var imgs = c.querySelectorAll('.xc-colors__stage img');
    var price = c.querySelector('[data-xc-colors-price]');
    var status = c.querySelector('[data-xc-colors-status]');
    var notify = c.querySelector('[data-xc-colors-notify]');
    var updated = c.querySelector('[data-xc-colors-updated]');
    var tId;
    c.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('input[type="radio"]')) return;
      c.querySelectorAll('.xc-colors__swatch').forEach(function (l) {
        l.classList.toggle('is-selected', l.contains(input));
      });
      imgs.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.xcColor === input.dataset.xcColor);
      });
      if (price && input.dataset.xcPrice) price.textContent = input.dataset.xcPrice;
      var soon = input.dataset.xcSoon || '';
      if (status) { status.textContent = soon; status.classList.toggle('is-soon', !!soon); }
      if (notify) notify.hidden = !soon;
      if (updated) {
        clearTimeout(tId);
        if (!soon) {
          updated.textContent = updated.dataset.xcUpdatedLabel || updated.textContent;
          requestAnimationFrame(function () { updated.classList.add('is-visible'); });
          tId = setTimeout(function () { updated.classList.remove('is-visible'); }, 2000);
        } else {
          updated.classList.remove('is-visible');
          updated.textContent = '';
        }
      }
      var vid = input.dataset.xcVariantId;
      if (vid) {
        var f = document.querySelector('[data-xc-variants] input[value="' + vid + '"]');
        if (f && !f.disabled && !f.checked) {
          f.checked = true;
          f.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  /* ---------- armor analysis (hotspot -> detail panel) ---------- */
  document.querySelectorAll('[data-xc-armor]').forEach(function (a) {
    var spots = a.querySelectorAll('.xc-armor__spot');
    var details = a.querySelectorAll('.xc-armor__detail');
    spots.forEach(function (s) {
      s.addEventListener('click', function () {
        spots.forEach(function (x) {
          x.classList.toggle('is-active', x === s);
          x.setAttribute('aria-expanded', x === s ? 'true' : 'false');
        });
        details.forEach(function (d) {
          d.classList.toggle('is-active', d.dataset.xcDetail === s.dataset.xcSpot);
        });
      });
    });
  });

  /* ---------- deployment scenes (tabs) ---------- */
  document.querySelectorAll('[data-xc-scenes]').forEach(function (sc) {
    var tabs = sc.querySelectorAll('.xc-scenes__tab');
    var scenes = sc.querySelectorAll('.xc-scenes__scene');
    var bar = sc.querySelector('.xc-scenes__bar');
    function place(t) {
      if (bar) { bar.style.width = t.offsetWidth + 'px'; bar.style.transform = 'translateX(' + t.offsetLeft + 'px)'; }
    }
    var act = sc.querySelector('.xc-scenes__tab.is-active');
    if (act) place(act);
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.xcScene === t.dataset.xcTab); });
      place(t);
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.tabIndex = t.classList.contains('is-active') ? 0 : -1;
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    });
    window.addEventListener('resize', function () {
      var a2 = sc.querySelector('.xc-scenes__tab.is-active');
      if (a2) place(a2);
    }, { passive: true });
  });

  /* ---------- storage compare slider ---------- */
  document.querySelectorAll('[data-xc-compare]').forEach(function (cp) {
    var range = cp.querySelector('.xc-compare__range');
    var before = cp.querySelector('.xc-compare__before');
    var handle = cp.querySelector('.xc-compare__handle');
    if (!range || !before) return;
    function set(v) {
      before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      if (handle) handle.style.left = v + '%';
      range.setAttribute('aria-valuetext', '収納後 ' + Math.round(100 - v) + '%表示');
    }
    range.addEventListener('keydown', function (e) {
      var d = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') d = 5;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') d = -5;
      if (!d) return;
      e.preventDefault();
      range.value = Math.max(0, Math.min(100, parseFloat(range.value) + d));
      set(range.value);
    });
    range.addEventListener('input', function () {
      requestAnimationFrame(function () { set(range.value); });
    });
    set(range.value);
    if (!reduced && window.matchMedia('(min-width: 990px)').matches && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en, io) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        var seq = [[50, 66, 600], [66, 50, 600]], i = 0;
        (function step() {
          if (i >= seq.length) return;
          var s = seq[i++], t0 = null;
          requestAnimationFrame(function fr(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / s[2], 1);
            var v = s[0] + (s[1] - s[0]) * (1 - Math.pow(1 - p, 3));
            set(v); range.value = v;
            if (p < 1) requestAnimationFrame(fr); else step();
          });
        })();
      }, { threshold: 0.5 }).observe(cp);
    }
  });

  /* ---------- magnetic CTA (hero + final, fine pointer only) ---------- */
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.xc-hero__actions .xc-btn, .xc-final__form .xc-btn').forEach(function (b) {
      var r = null;
      b.addEventListener('pointermove', function (e) {
        r = r || b.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        b.style.setProperty('--xc-mx', Math.max(-3, Math.min(3, dx * 0.08)) + 'px');
        b.style.setProperty('--xc-my', Math.max(-3, Math.min(3, dy * 0.08)) + 'px');
      });
      b.addEventListener('pointerleave', function () {
        b.style.removeProperty('--xc-mx');
        b.style.removeProperty('--xc-my');
        r = null;
      });
    });
  }

  /* ---------- cart add feedback (progressive enhancement) ---------- */
  document.querySelectorAll('form[data-xc-product-form]').forEach(function (form) {
    var btn = form.querySelector('[data-xc-add]');
    if (!btn || !window.fetch) return;
    var label = btn.querySelector('[data-xc-add-label]');
    var status = form.querySelector('[data-xc-add-status]');
    var errEl = form.querySelector('[data-xc-form-error]');
    var t;
    /* 個体差の同意ゲート: チェックされるまで全ての購入経路(メインCTA/カード購入ボタン)をブロック */
    var ackCb = form.querySelector('[data-xc-ack-cb]');
    var ackAttnT;
    function xcSyncAck() {
      if (!ackCb) return;
      btn.classList.toggle('is-locked', !ackCb.checked);
      btn.setAttribute('aria-disabled', ackCb.checked ? 'false' : 'true');
    }
    if (ackCb) { ackCb.addEventListener('change', xcSyncAck); xcSyncAck(); }
    form.addEventListener('submit', function (e) {
      /* カード「カートに入れる」経由の追加は決済へ直行せずページに留まる。
         フラグはゲートで弾かれた場合に残らないよう、最初に読み取って必ず消す */
      var stayAfterAdd = form.dataset.xcStay === '1';
      delete form.dataset.xcStay;
      if (ackCb && !ackCb.checked) {
        e.preventDefault();
        var ackRow = ackCb.closest('[data-xc-ack]');
        if (ackRow) {
          ackRow.classList.remove('is-attn');
          void ackRow.offsetWidth;
          ackRow.classList.add('is-attn');
          clearTimeout(ackAttnT);
          ackAttnT = setTimeout(function () { ackRow.classList.remove('is-attn'); }, 1800);
          ackRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        ackCb.focus({ preventScroll: true });
        if (status) status.textContent = '個体差についてご確認のうえ、チェックを入れると購入できます';
        return;
      }
      var checked = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
      if (checked && checked.dataset.xcAvailable === 'false') { e.preventDefault(); return; }
      e.preventDefault();
      clearTimeout(t);
      if (errEl) errEl.hidden = true;
      btn.disabled = true;
      if (label) label.textContent = btn.dataset.xcLabelProcessing || 'PROCESSING…';
      if (status) status.textContent = 'PROCESSING…';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (item) {
          if (label) label.textContent = btn.dataset.xcLabelAdded || 'ADDED ✓';
          document.dispatchEvent(new CustomEvent('xc:cart:added'));
          if (stayAfterAdd) {
            /* カードの「カートに入れる」: ページに留まりバッジ・ステータスのみ更新 */
            if (status) status.textContent = '✓ カートに追加しました';
            document.querySelectorAll('[data-xc-cart-link]').forEach(function (l) { l.hidden = false; });
            t = setTimeout(function () {
              if (label) label.textContent = btn.dataset.xcLabelDefault || '予約する';
              btn.disabled = false;
            }, 1600);
            return;
          }
          if (status) status.textContent = '✓ カートに追加しました。ご購入手続きへ進みます…';
          /* 決済ページへ直行(ボタン文言「ご購入手続きへ進む」と一致させる)。
             ボタンはdisabledのまま遷移し二重送信を防ぐ */
          window.location.href = root + 'checkout';
        })
        .catch(function () {
          if (label) label.textContent = btn.dataset.xcLabelDefault || '予約する';
          if (status) status.textContent = '';
          btn.disabled = false;
          if (errEl) errEl.hidden = false;
        });
    });
  });

  /* ---------- final CTA: variant sync (price / soon / sticky) ---------- */
  document.querySelectorAll('[data-xc-variants]').forEach(function (group) {
    var form = group.closest('form');
    if (!form) return;
    var formPrice = form.querySelector('[data-xc-form-price]');
    var finalPrice = document.querySelector('[data-xc-final-price]');
    var stickyPrice = document.querySelector('[data-xc-sticky-price]');
    var addBtn = form.querySelector('[data-xc-add]');
    var notifyBtn = form.querySelector('[data-xc-form-notify]');

    /* COMING SOON variants: enable for selection (purchase stays blocked) */
    group.querySelectorAll('input[data-xc-soon-enable]').forEach(function (i) {
      i.disabled = false;
    });

    group.addEventListener('change', function (e) {
      var input = e.target;
      if (input.name !== 'id') return;
      group.querySelectorAll('.xc-colors__swatch').forEach(function (l) {
        l.classList.toggle('is-selected', l.contains(input));
      });
      var p = input.dataset.xcPrice;
      if (p) {
        if (formPrice) formPrice.textContent = p;
        if (finalPrice) finalPrice.textContent = p;
        if (stickyPrice) stickyPrice.textContent = p;
      }
      var scEl = document.querySelector('[data-xc-sticky-color]');
      if (scEl && input.dataset.xcName) scEl.textContent = input.dataset.xcName;
      if (input.dataset.xcPriceIncl) {
        document.querySelectorAll('[data-xc-price-incl-view], [data-xc-spf-incl-price]').forEach(function (el) {
          el.textContent = input.dataset.xcPriceIncl;
        });
      }
      var soon = input.dataset.xcAvailable === 'false';
      if (addBtn) addBtn.hidden = soon;
      if (notifyBtn) notifyBtn.hidden = !soon;
    });
  });

  /* ---------- color & purchase panel sync ---------- */
  document.querySelectorAll('[data-xc-purchase]').forEach(function (sec) {
    var nameEl = sec.querySelector('[data-xc-selected-name]');
    var priceEl = sec.querySelector('[data-xc-colors-price]');
    var addBtn = sec.querySelector('[data-xc-add]');
    var notifyBtn = sec.querySelector('[data-xc-form-notify]');
    var stickyBtn = document.querySelector('[data-xc-sticky-cta]');
    var sticky = document.querySelector('.xc-sticky');
    var stickyPrice = document.querySelector('[data-xc-sticky-price]');
    var stickyColor = document.querySelector('[data-xc-sticky-color]');
    /* CTA内にアイコンがあるためラベルはspanを優先して書き換える(なければ従来どおり全文) */
    var stickyBtnLabel = stickyBtn ? stickyBtn.querySelector('[data-xc-sticky-cta-label]') || stickyBtn : null;
    sec.querySelectorAll('input[data-xc-soon-enable]').forEach(function (i) { i.disabled = false; });
    function apply(input) {
      sec.querySelectorAll('.xc-colors__swatch').forEach(function (l) {
        l.classList.toggle('is-selected', l.contains(input));
      });
      if (nameEl && input.dataset.xcName) nameEl.textContent = input.dataset.xcName;
      if (priceEl && input.dataset.xcPrice) priceEl.textContent = input.dataset.xcPrice;
      if (stickyPrice && input.dataset.xcPrice) stickyPrice.textContent = input.dataset.xcPrice;
      if (stickyColor && input.dataset.xcName) stickyColor.textContent = input.dataset.xcName;
      if (input.dataset.xcPriceIncl) {
        document.querySelectorAll('[data-xc-price-incl-view], [data-xc-spf-incl-price]').forEach(function (el) {
          el.textContent = input.dataset.xcPriceIncl;
        });
      }
      var soon = input.dataset.xcAvailable === 'false';
      var preorder = input.dataset.xcPreorder === 'true';
      if (addBtn) addBtn.hidden = soon;
      if (notifyBtn) notifyBtn.hidden = !soon;
      var availEl = sec.querySelector('[data-xc-avail]');
      if (availEl) {
        if (!availEl.dataset.xcOrig) availEl.dataset.xcOrig = availEl.textContent;
        availEl.textContent = preorder ? (sec.dataset.xcPreorderNote || availEl.dataset.xcOrig) : availEl.dataset.xcOrig;
        availEl.classList.toggle('is-preorder', preorder);
        availEl.hidden = soon;
      }
      if (stickyBtn && sticky) {
        if (soon) {
          stickyBtnLabel.textContent = sticky.dataset.xcSoonLabel || '入荷通知を受け取る';
          stickyBtn.setAttribute('href', sec.dataset.xcNotifyUrl || sticky.dataset.xcNotifyUrl || '#xc-faq');
        } else {
          stickyBtnLabel.textContent = sticky.dataset.xcCtaLabel || '今すぐ手に入れる';
          stickyBtn.setAttribute('href', '#xc-buy');
        }
      }
      /* 他フォーム(最終CTA等)のバリアント選択を同期 */
      document.querySelectorAll('form[data-xc-product-form]').forEach(function (f) {
        if (sec.contains(f)) return;
        var r = f.querySelector('input[name="id"][value="' + input.value + '"]');
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    sec.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) apply(e.target);
    });
    /* カード内ボタン: 購入=選択+カート追加 / 入荷通知=選択+通知先へ */
    sec.addEventListener('click', function (e) {
      var buy = e.target.closest('[data-xc-card-buy]');
      var noti = e.target.closest('[data-xc-card-notify]');
      if (!buy && !noti) return;
      e.preventDefault();
      var card = e.target.closest('.xc-colors__swatch');
      var cardInput = card && card.querySelector('input[type="radio"]');
      if (cardInput && !cardInput.disabled) { cardInput.checked = true; apply(cardInput); }
      if (buy) {
        if (addBtn && !addBtn.hidden) {
          /* カードの「カートに入れる」は決済へ直行せずページに留まる */
          var cardForm = addBtn.closest('form');
          if (cardForm) cardForm.dataset.xcStay = '1';
          addBtn.click();
        }
      } else {
        window.location.href = sec.dataset.xcNotifyUrl || '#xc-faq';
      }
    });
    sec.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-xc-card-buy], [data-xc-card-notify]')) {
        e.preventDefault();
        e.target.click();
      }
    });
    var init = sec.querySelector('input[type="radio"]:checked');
    if (init) apply(init);
  });

  /* ---------- sticky CTA: show after hero CTA leaves viewport ---------- */
  var sticky = document.querySelector('.xc-sticky');
  /* 出現トリガーは「表示中の」ヒーローCTAにする。
     モバイルはPC用ヒーローが非表示のため、.xc-hero__actionsだけを見ると一度も発火しない */
  var sentinel = null;
  document.querySelectorAll('.xc-tmhero-cta, .xc-hero__actions').forEach(function (el) {
    if (!sentinel && el.offsetParent !== null) sentinel = el;
  });
  if (sticky && sentinel && 'IntersectionObserver' in window) {
    document.body.classList.add('xc-body-has-sticky');
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ---------- 固定フッターのカート点数バッジ ----------
     ヘッダーのバッジ処理はヘッダー内スコープのため、フッター分をここで同期する。
     チェックアウト/カートからブラウザバックで戻った時(BFCache)も件数を取り直す */
  (function () {
    var scBtn = document.querySelector('[data-xc-sticky-cart]');
    var scCount = document.querySelector('[data-xc-sticky-cart-count]');
    if (scCount && window.fetch) {
      var setStickyCart = function (n) {
        scCount.textContent = n;
        scCount.hidden = !(n > 0);
        if (scBtn) scBtn.setAttribute('aria-label', 'カートを見る(' + n + '点入っています)');
        if (n > 0 && !reduced) {
          scCount.classList.remove('is-bump');
          void scCount.offsetWidth;
          scCount.classList.add('is-bump');
        }
      };
      var refreshStickyCart = function () {
        fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) { setStickyCart(c.item_count); }).catch(function () {});
      };
      document.addEventListener('xc:cart:count', function (e) {
        setStickyCart(e.detail && typeof e.detail.count !== 'undefined' ? e.detail.count : 0);
      });
      document.addEventListener('xc:cart:added', refreshStickyCart);
    }
    window.addEventListener('pageshow', function (e) {
      /* xc:cart:addedを配信するとヘッダー側バッジも同時に取り直される */
      if (e.persisted) document.dispatchEvent(new CustomEvent('xc:cart:added'));
    });
  })();

  /* ---------- FAQ: animated open/close (grid-rows 240ms) + aria sync ---------- */
  document.querySelectorAll('.xc-faq__item').forEach(function (d) {
    var s = d.querySelector('summary');
    if (!s) return;
    s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    d.classList.toggle('is-open', d.open);
    d.addEventListener('toggle', function () { s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); });
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (!d.open) {
        d.open = true;
        requestAnimationFrame(function () { d.classList.add('is-open'); });
      } else {
        d.classList.remove('is-open');
        setTimeout(function () { d.open = false; }, reduced ? 0 : 240);
      }
    });
  });
})();
